import $api from '../index'
// 获取菜单权限数组
export const getMenu = () => {
  return $api.get('/menu/left/menu/tree')
}
// 获取路由权限数组
export default {}
